/* Viva Voce custom account popover (signed-out header entry).
   Brand-styled dropdown matching the reference Account popover. */
if (!customElements.get('vv-account-popover')) {
  customElements.define(
    'vv-account-popover',
    class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-vv-popover-trigger]');
        this.panel = this.querySelector('[data-vv-popover-panel]');
        if (!this.trigger || !this.panel) return;

        this._onDocClick = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        this._onKey = (e) => {
          if (e.key === 'Escape') {
            this.close();
            this.trigger.focus();
          }
        };

        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });

        this.querySelectorAll('[data-vv-popover-close]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.close();
            this.trigger.focus();
          });
        });
      }

      get isOpen() {
        return !this.panel.hasAttribute('hidden');
      }

      toggle() {
        if (this.isOpen) this.close();
        else this.open();
      }

      open() {
        this.panel.removeAttribute('hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);
        const first = this.panel.querySelector('a, button');
        if (first) first.focus();
      }

      close() {
        if (!this.isOpen) return;
        this.panel.setAttribute('hidden', '');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
      }
    }
  );
}
